<div *ngIf="showPrimarySpinner" class="spinner-wrapper">
  <mat-spinner class="spinner-inner"></mat-spinner>
</div>

<div *ngIf="students">
  <!-- Button design for desktop -->
  <div
    *ngIf="!students['tpv_payment'] && !mobileLandscapeImage"
    class="floating-button-wrapper"
    (mouseenter)="hoverOn('order_btn')"
    (mouseleave)="hoverOff('order_btn')"
  >
    <!-- <button *ngIf="!showReservationSummary" mat-flat-button matBadge="{{badgeNumber > 0 ? badgeNumber : null}}"
            (click)="proceedToReservationCheckout()" [disabled]="badgeNumber < 1"
            [ngClass]="{'disabled-button': badgeNumber < 1}">
            <span>{{ 'buttons.order' | translate }}</span>
            <mat-icon>shopping_bag</mat-icon>
        </button> -->

    <button
      *ngIf="!showReservationSummary && !mobileLandscapeImage"
      class="reservation-button"
      [ngClass]="{ 'extended-fab-button': floatingButtonExtend }"
      mat-fab
      color="primary"
      matBadge="{{ badgeNumber > 0 ? badgeNumber : null }}"
      (click)="proceedToReservationCheckout()"
      [disabled]="badgeNumber < 1"
    >
      <span
        [ngClass]="{ animation: floatingButtonExtend }"
        [hidden]="!floatingButtonExtend"
        >{{ "buttons.order" | translate }}</span
      >
      <mat-icon>shopping_bag</mat-icon>
    </button>
  </div>

  <!-- Button design for mobile -->
  <div
    *ngIf="!students['tpv_payment'] && mobileLandscapeImage"
    class="floating-button-wrapper-scale-down"
    (mouseenter)="hoverOn('order_btn')"
    (mouseleave)="hoverOff('order_btn')"
  >
    <button
      *ngIf="!showReservationSummary && mobileLandscapeImage"
      class="reservation-button extended-fab-button scale-down"
      mat-fab
      color="primary"
      matBadge="{{ badgeNumber > 0 ? badgeNumber : null }}"
      (click)="proceedToReservationCheckout()"
      [disabled]="badgeNumber < 1"
    >
      <span>{{ "buttons.order" | translate }}</span>
      <mat-icon>shopping_bag</mat-icon>
    </button>
  </div>

  <!-- Floating back button for reservation page -->
  <div class="floating-button-wrapper-down">
    <button
      *ngIf="showReservationSummary"
      mat-flat-button
      (click)="stepperIndexHandler('back')"
      style="background-color: white; color: #5fbeb5; border: 1px solid #5fbeb5"
    >
      <mat-icon style="color: #5fbeb5; margin-right: 8px"
        >keyboard_backspace</mat-icon
      >
      <span style="color: #5fbeb5">{{ "buttons.return" | translate }}</span>
    </button>
    <button
      *ngIf="showReservationSummary && mobileSummaryItems && stepperIndex == 0"
      mat-flat-button
      (click)="stepperIndexHandler('next')"
      style="
        background-color: #5fbeb5;
        color: white;
        border: 1px solid #5fbeb5;
        margin-left: 6px;
      "
    >
      <mat-icon style="color: white; margin-right: 8px">arrow_right</mat-icon>
      <span style="color: white">{{ "inputs.next" | translate }}</span>
    </button>
  </div>

  <div
    *ngIf="students['tpv_payment'] && !mobileLandscapeImage"
    class="floating-button-wrapper"
    (mouseenter)="hoverOn('order_btn')"
    (mouseleave)="hoverOff('order_btn')"
  >
    <!-- <button mat-flat-button matBadge="{{badgeNumber > 0 ? badgeNumber : null}}" (click)="goTo('/shopping-cart')"
            [disabled]="badgeNumber < 1" [ngClass]="{'disabled-button': badgeNumber < 1}">
            <span>Cesta</span>
            <mat-icon>shopping_cart</mat-icon>
        </button> -->

    <button
      *ngIf="!showReservationSummary"
      class="reservation-button"
      [ngClass]="{ 'extended-fab-button': floatingButtonExtend }"
      mat-fab
      color="primary"
      matBadge="{{ badgeNumber > 0 ? badgeNumber : null }}"
      (click)="goTo('/shopping-cart')"
      [disabled]="badgeNumber < 1"
    >
      <span
        [ngClass]="{ animation: floatingButtonExtend }"
        [hidden]="!floatingButtonExtend"
        >{{ "buttons.cart" | translate }}</span
      >
      <mat-icon>shopping_cart</mat-icon>
    </button>
  </div>

  <div
    *ngIf="students['tpv_payment'] && mobileLandscapeImage"
    class="floating-button-wrapper-scale-down"
    (mouseenter)="hoverOn('order_btn')"
    (mouseleave)="hoverOff('order_btn')"
  >
    <!-- <button mat-flat-button matBadge="{{badgeNumber > 0 ? badgeNumber : null}}" (click)="goTo('/shopping-cart')"
            [disabled]="badgeNumber < 1" [ngClass]="{'disabled-button': badgeNumber < 1}">
            <span>Cesta</span>
            <mat-icon>shopping_cart</mat-icon>
        </button> -->

    <button
      *ngIf="!showReservationSummary"
      class="reservation-button extended-fab-button scale-down"
      mat-fab
      color="primary"
      matBadge="{{ badgeNumber > 0 ? badgeNumber : null }}"
      (click)="goTo('/shopping-cart')"
      [disabled]="badgeNumber < 1"
    >
      <span>{{ "buttons.cart" | translate }}</span>
      <mat-icon>shopping_cart</mat-icon>
    </button>
  </div>
</div>

<div *ngIf="students && !showReservationSummary" class="main-wrapper">
  <div class="header-wrapper">
    <div class="header-photo">
      <img [src]="students['school_photo']" alt="School logo" />
    </div>
    <div class="header-school-data">
      <p style="text-transform: uppercase">
        {{ "menu.grade" | translate }}: {{ students["yearperiod_name"] }}
      </p>
      <p>{{ students["school_name"] }}</p>
    </div>

    <mat-divider [vertical]="true"></mat-divider>

    <div class="header-student-data">
      <p>{{ students["name"] }}</p>
      <p>
        <span>{{ "menu.stage" | translate }}: </span>
        {{ students["stage_name"] }}
      </p>
      <p>
        <span>{{ "menu.class" | translate }}: </span>
        {{ students["grade_name"] }}
      </p>
      <p>
        <span>{{ "tables.num_list" | translate }}: </span>
        {{ students["num_list"] }}
      </p>
    </div>
  </div>

  <div *ngIf="!students['tpv_payment']" class="reservation-notice-wrapper">
    <span>{{ "text.reservation_notice" | translate }}</span>
  </div>

  <div style="text-align: center; margin-top: 24px">
    <!-- <p style="font-size: 18px; font-weight: 500;">{{'text.no_products_available' | translate}}
        </p> -->
    <div style="flex-direction: row" style="display: {{ 'es' | translate }}">
      <p style="font-size: 18px; font-weight: 500">
        {{ msg ? msg.notification_es : "" }}
      </p>
    </div>
    <div style="flex-direction: row" style="display: {{ 'en' | translate }}">
      <p style="font-size: 18px; font-weight: 500">
        {{ msg ? msg.notification_en : "" }}
      </p>
    </div>
    <div style="flex-direction: row" style="display: {{ 'cat' | translate }}">
      <p style="font-size: 18px; font-weight: 500">
        {{ msg ? msg.notification_cat : "" }}
      </p>
    </div>
  </div>

  <!-- <div class="header-wrapper">
        <mat-card>
            SCHOOL LOGO
            <div class="school-logo-wrapper">
                <a [href]="students['school_photo']" target="_blank"><img class="school-logo"
                        [src]="students['school_photo']"></a>
            </div>
            SCHOOL ITEMS
            <div class="school-items">
                <mat-card-title>
                    <mat-icon>school</mat-icon> : {{ students['school_name'] }}
                </mat-card-title>
                <mat-card-content>
                    <mat-list>
                        <mat-list-item>
                            <span>{{ 'tables.yearperiod' | translate}}: </span>
                            {{students['yearperiod_name']}}
                        </mat-list-item>
                    </mat-list>
                </mat-card-content>
            </div>

            STUDENT ITEMS
            <div class="student-items">
                <mat-card-title>
                    <mat-icon>face</mat-icon> : {{ students['name'] }}
                </mat-card-title>
                <mat-card-content>
                    <mat-list>
                        <mat-list-item><span>{{ 'menu.stage' | translate }}: </span> {{ students['stage_name'] }}
                        </mat-list-item>
                        <mat-list-item><span>{{ 'menu.grade' | translate }}: </span> {{ students['grade_name'] }}
                        </mat-list-item>
                        <mat-list-item><span>{{ 'tables.num_list' | translate }}: </span> {{ students['num_list'] }}
                        </mat-list-item>
                    </mat-list>
                </mat-card-content>
            </div>


        </mat-card>
    </div> -->

  <!-- PHOTO SECTION (PRIMARY, SECONDARY, GROUP PRIMARY, GROUP SECONDARY) -->
  <!-- <div class="photo-items-wrapper">
        <div class="photo-items">
            <div class="student-photo primary-photo-margin">
                <a [href]="students['primary_photo']" target="_blank"><img #primaryPhoto
                        [src]="students['primary_photo']" class="student-photo-size"></a>
                <span>{{ 'captions.individual_photo' | translate}}</span>
            </div>
            <div class="student-photo" *ngIf="students['primary_group_photo'] != ''">
                <a [href]="students['primary_group_photo']" target="_blank"><img [src]="students['primary_group_photo']"
                        class="{{ mobileLandscapeImage ? 'landscape-mobile' : 'student-photo-size' }}"></a>
                <span style="{{ mobileLandscapeImage ? 'margin-left: 2%' : '' }}">{{ 'captions.class_group_photo' |
                    translate}}</span>
            </div>
        </div>
    </div>
    <div class="photo-items-wrapper">
        <div class="photo-items" *ngIf="students['secondary_photo'] != ''">
            <div class="student-photo primary-photo-margin">
                <a [href]="students['secondary_photo']" target="_blank"><img [src]="students['secondary_photo']"
                        class="student-photo-size"></a>
                <span>{{ 'captions.multiple_photo' | translate}}</span>
            </div>
            <div class="student-photo" *ngIf="students['secondary_group_photo'] != ''">
                <a [href]="students['secondary_group_photo']" target="_blank"><img
                        [src]="students['secondary_group_photo']"
                        class="{{ mobileLandscapeImage ? 'landscape-mobile' : 'student-photo-size' }}"></a>
                <span style="{{ mobileLandscapeImage ? 'margin-left: 2%' : '' }}">{{ 'captions.funny_photo' |
                    translate}}</span>
            </div>
        </div>
    </div> -->

  <div *ngIf="photoURLArray.length > 0" class="photo-grid">
    <div class="photo-row">
      <div *ngIf="photoURLArray[0]">
        <img
          class="student-photo"
          [src]="photoURLArray[0].url"
          (click)="!mobileView && openPhotoPreview(photoURLArray[0].url)"
          [ngClass]="{ 'zoom-in-cursor': !mobileView }"
        />
        <span>{{ photoURLArray[0].caption | translate }}</span>
      </div>
      <div *ngIf="photoURLArray[1]">
        <img
          class="student-photo"
          [src]="photoURLArray[1].url"
          (click)="!mobileView && openPhotoPreview(photoURLArray[1].url)"
          [ngClass]="{ 'zoom-in-cursor': !mobileView }"
        />
        <span>{{ photoURLArray[1].caption | translate }}</span>
      </div>
    </div>
    <div *ngIf="photoURLArray.length > 1" class="photo-row">
      <div *ngIf="photoURLArray[2]">
        <img
          class="student-photo"
          [src]="photoURLArray[2].url"
          (click)="!mobileView && openPhotoPreview(photoURLArray[2].url)"
          [ngClass]="{ 'zoom-in-cursor': !mobileView }"
        />
        <span>{{ photoURLArray[2].caption | translate }}</span>
      </div>
      <div *ngIf="photoURLArray[3]">
        <img
          class="student-photo"
          [src]="photoURLArray[3].url"
          (click)="!mobileView && openPhotoPreview(photoURLArray[3].url)"
          [ngClass]="{ 'zoom-in-cursor': !mobileView }"
        />
        <span>{{ photoURLArray[3].caption | translate }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="showSecondarySpinner" class="spinner-wrapper">
    <mat-spinner class="spinner-inner"></mat-spinner>
  </div>

  <div class="product-items-wrapper">
    <div
      *ngIf="products && products.length < 1"
      style="text-align: center; margin-top: 24px"
    >
      <!-- <p style="font-size: 18px; font-weight: 500;">{{'text.no_products_available' | translate}}
            </p> -->
      <div style="flex-direction: row" style="display: {{ 'es' | translate }}">
        <p style="font-size: 18px; font-weight: 500">{{ msg.es }}</p>
      </div>
      <div style="flex-direction: row" style="display: {{ 'en' | translate }}">
        <p style="font-size: 18px; font-weight: 500">{{ msg.en }}</p>
      </div>
      <div style="flex-direction: row" style="display: {{ 'cat' | translate }}">
        <p style="font-size: 18px; font-weight: 500">{{ msg.cat }}</p>
      </div>
    </div>

    <div *ngIf="products && products.length > 0" class="product-items">
      <div style="padding: 14px 68px 44px">
        <mat-divider style="width: 100%; border-top-color: black"></mat-divider>
        <p style="font-size: 24px; margin-top: 18px">
          {{ "titles.list.available_lots" | translate }}
        </p>
        <p>{{ "text.priority_products_intro" | translate }}</p>
      </div>

      <!-- PRODUCT ITEMS TABLE -->
      <div *ngIf="!mobileView" class="product-table-wrapper">
        <mat-table
          [dataSource]="highlightedProducts"
          class="mat-elevation-z8 product-table"
          [ngClass]="{ 'product-table-loading': updatingShoppingCart.updating }"
        >
          <!-- Photo Column -->
          <ng-container matColumnDef="photo">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let product">
              <img
                (click)="openPhotoPreview(product.product_image)"
                [src]="product.product_image"
              />
            </mat-cell>
          </ng-container>

          <!-- Description Column -->
          <ng-container matColumnDef="description">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let product">
              <div class="product-description-wrapper">
                <div class="product-description-name">
                  <span style="display: {{ 'es' | translate }}">{{
                    product.name_es
                  }}</span>
                  <span style="display: {{ 'en' | translate }}">{{
                    product.name_en
                  }}</span>
                  <span style="display: {{ 'cat' | translate }}">{{
                    product.name_cat
                  }}</span>
                </div>
                <div class="product-description-description">
                  <div
                    *ngFor="let description of productDescriptions[product.id]"
                  >
                    <div>
                      <span style="display: {{ 'es' | translate }}"
                        >{{ description.unit ? description.unit : "*" }} &nbsp;
                        {{ description.description_es }}</span
                      >
                      <span style="display: {{ 'en' | translate }}"
                        >{{ description.unit ? description.unit : "*" }} &nbsp;
                        {{ description.description_en }}</span
                      >
                      <span style="display: {{ 'cat' | translate }}"
                        >{{ description.unit ? description.unit : "*" }} &nbsp;
                        {{ description.description_cat }}</span
                      >
                    </div>
                  </div>
                </div>

                <div class="product-description-value">
                  <div class="product-value">
                    <div>
                      <span class="grey-text"
                        >{{ "tables.pack_price" | translate }}:</span
                      >
                      {{ prodQtyOverview[product.id].value }}
                      <span style="font-size: 14px">{{
                        "tables.vat_included" | translate
                      }}</span>
                    </div>
                  </div>

                  <div class="product-quantity-selector">
                    <span style="font-size: 14px; padding-left: 6px">
                      {{ "buttons.quantity_short" | translate }}:
                    </span>

                    <button
                      mat-button
                      [matMenuTriggerFor]="summaryMenu"
                      class="quantity-select-button"
                    >
                      <span>{{ prodQtyOverview[product.id].unit }} &nbsp;</span>
                      <mat-icon> keyboard_arrow_down </mat-icon>
                    </button>
                    <mat-menu #summaryMenu="matMenu">
                      <div style="height: 200px; text-align: center">
                        <div *ngFor="let number of numberList">
                          <button
                            mat-menu-item
                            (click)="
                              productQuantitySelectHandler(number, product.id)
                            "
                            style="text-align: center"
                          >
                            <span>{{ number }}</span>
                          </button>
                        </div>
                      </div>
                    </mat-menu>
                    <div class="add-to-checkout-wrapper">
                      <button
                        *ngIf="!students['tpv_payment']"
                        mat-flat-button
                        (click)="addProductToCheckout(product.id)"
                        class="add-to-checkout-button"
                      >
                        <span>{{
                          "buttons.add_to_reservation" | translate
                        }}</span>
                      </button>

                      <button
                        *ngIf="students['tpv_payment']"
                        mat-flat-button
                        (click)="addToShoppingCart(product.id)"
                        class="add-to-checkout-button"
                      >
                        <span>{{ "buttons.add_to_cart" | translate }}</span>
                      </button>
                    </div>
                  </div>
                </div>

                <mat-progress-bar
                  *ngIf="
                    this.updatingShoppingCart.updating &&
                    this.updatingShoppingCart.itemId == product.id
                  "
                  style="width: 98%; margin-top: 24px"
                  mode="indeterminate"
                >
                </mat-progress-bar>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>

      <!-- PRIORITY PRODUCTS GRID -->
      <div *ngIf="mobileView">
        <div class="container">
          <div class="cards">
            <div *ngFor="let product of highlightedProducts">
              <div class="card highlighted">
                <div>
                  <img class="grid-image" [src]="product.product_image" />
                </div>

                <div class="grid-card-title">
                  <span style="display: {{ 'es' | translate }}">{{
                    product.name_es
                  }}</span>
                  <span style="display: {{ 'en' | translate }}">{{
                    product.name_en
                  }}</span>
                  <span style="display: {{ 'cat' | translate }}">{{
                    product.name_cat
                  }}</span>
                </div>
                <mat-divider style="width: 95%"></mat-divider>
                <div
                  *ngFor="let description of productDescriptions[product.id]"
                >
                  <div>
                    <span style="display: {{ 'es' | translate }}"
                      >{{ description.unit ? description.unit : "*" }} &nbsp;
                      {{ description.description_es }}</span
                    >
                    <span style="display: {{ 'en' | translate }}"
                      >{{ description.unit ? description.unit : "*" }} &nbsp;
                      {{ description.description_en }}</span
                    >
                    <span style="display: {{ 'cat' | translate }}"
                      >{{ description.unit ? description.unit : "*" }} &nbsp;
                      {{ description.description_cat }}</span
                    >
                  </div>
                </div>
                <div class="grid-product-value">
                  <span>{{ product.value }}€ </span>
                  <span>{{ "tables.vat_included" | translate }}</span>
                </div>
                <div class="product-card-actions">
                  <!-- QUANTITY SELECTOR BUTTON -->
                  <div class="grid-product-quantity-selector">
                    <span style="font-size: 14px">
                      {{ "buttons.quantity_short" | translate }}:
                    </span>

                    <button
                      mat-button
                      [matMenuTriggerFor]="summaryMenu"
                      class="quantity-select-button"
                      style="background-color: white"
                    >
                      <span style="color: teal"
                        >{{ prodQtyOverview[product.id].unit }} &nbsp;</span
                      >
                      <mat-icon style="color: teal">
                        keyboard_arrow_down
                      </mat-icon>
                    </button>
                    <mat-menu #summaryMenu="matMenu">
                      <div style="height: 200px; text-align: center">
                        <div *ngFor="let number of numberList">
                          <button
                            mat-menu-item
                            (click)="
                              productQuantitySelectHandler(number, product.id)
                            "
                            style="text-align: center"
                          >
                            <span>{{ number }}</span>
                          </button>
                        </div>
                      </div>
                    </mat-menu>
                  </div>

                  <!-- ADD TO CART/RESERVATION BUTTON -->
                  <button
                    *ngIf="!students['tpv_payment']"
                    mat-flat-button
                    (click)="addProductToCheckout(product.id)"
                    class="add-to-checkout-button"
                  >
                    <span style="color: teal">{{
                      "buttons.add_product" | translate
                    }}</span>
                  </button>

                  <button
                    *ngIf="students['tpv_payment']"
                    mat-flat-button
                    (click)="addToShoppingCart(product.id)"
                    class="add-to-checkout-button"
                  >
                    <span style="color: teal">{{
                      "buttons.add_product" | translate
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="padding: 64px 68px 0">
        <mat-divider style="width: 100%; border-top-color: black"></mat-divider>

        <div>
          <p style="font-weight: bold; font-size: 18px; margin-top: 18px">
            {{ "titles.list.add_other_products" | translate }}
          </p>
          <p>{{ "text.non_priority_products_intro" | translate }}</p>
        </div>
      </div>
      <!-- NON PRIORITY PRODUCTS GRID -->
      <div class="non-priority-items-wrapper">
        <div class="container">
          <div class="cards">
            <div *ngFor="let product of nonHighlightedProducts">
              <div class="card">
                <div>
                  <img
                    class="grid-image"
                    [src]="product.product_image"
                    (click)="
                      !mobileView && openPhotoPreview(product.product_image)
                    "
                    [ngClass]="{ 'zoom-in-cursor': !mobileView }"
                  />
                </div>

                <div class="grid-card-title">
                  <span style="display: {{ 'es' | translate }}">{{
                    product.name_es
                  }}</span>
                  <span style="display: {{ 'en' | translate }}">{{
                    product.name_en
                  }}</span>
                  <span style="display: {{ 'cat' | translate }}">{{
                    product.name_cat
                  }}</span>
                </div>

                <mat-divider style="width: 95%; margin: 8px"></mat-divider>

                <div class="grid-product-value">
                  <span>{{ product.value }}€ </span>
                  <span>{{ "tables.vat_included" | translate }}</span>
                </div>
                <div class="product-card-actions">
                  <!-- QUANTITY SELECTOR BUTTON -->
                  <div class="grid-product-quantity-selector">
                    <span style="font-size: 14px">
                      {{ "buttons.quantity_short" | translate }}:
                    </span>

                    <button
                      mat-button
                      [matMenuTriggerFor]="summaryMenu"
                      class="quantity-select-button"
                    >
                      <span>{{ prodQtyOverview[product.id].unit }} &nbsp;</span>
                      <mat-icon> keyboard_arrow_down </mat-icon>
                    </button>
                    <mat-menu #summaryMenu="matMenu">
                      <div style="height: 200px; text-align: center">
                        <div *ngFor="let number of numberList">
                          <button
                            mat-menu-item
                            (click)="
                              productQuantitySelectHandler(number, product.id)
                            "
                            style="text-align: center"
                          >
                            <span>{{ number }}</span>
                          </button>
                        </div>
                      </div>
                    </mat-menu>
                  </div>

                  <!-- ADD TO CART/RESERVATION BUTTON -->
                  <button
                    *ngIf="!students['tpv_payment']"
                    mat-flat-button
                    (click)="addProductToCheckout(product.id)"
                    class="add-to-checkout-button"
                  >
                    <span>{{ "buttons.add_product" | translate }}</span>
                  </button>

                  <button
                    *ngIf="students['tpv_payment']"
                    mat-flat-button
                    (click)="addToShoppingCart(product.id)"
                    class="add-to-checkout-button"
                  >
                    <span>{{ "buttons.add_product" | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="selectedProducts.length > 0 && !students['tpv_payment']"
        class="checkout-button-wrapper"
      >
        <button
          mat-flat-button
          (click)="proceedToReservationCheckout()"
          class="checkout-button"
        >
          <span> {{ "buttons.order" | translate }} </span>
          <mat-icon>shopping_bag</mat-icon>
        </button>
      </div>

      <div *ngIf="students['tpv_payment']" class="checkout-button-wrapper">
        <button
          mat-flat-button
          (click)="goTo('/shopping-cart')"
          class="checkout-button"
          [disabled]="badgeNumber < 1"
        >
          <span>{{ "buttons.go_to_payment" | translate }}</span>
          <mat-icon>shopping_cart</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="students && showReservationSummary">
  <div
    *ngIf="selectedProducts.length < 1"
    class="no-products-wrapper"
    (click)="proceedToReservationCheckout()"
  >
    <div class="no-products">
      <p style="text-decoration: underline; cursor: pointer">
        {{ "alerts.no_products" | translate }}
      </p>
    </div>
  </div>

  <div class="reservation-checkout" *ngIf="selectedProducts.length > 0">
    <!-- <div class="reservation-checkout-header" #summaryHeader>
            <span class="reservation-checkout-title">Completa su reserva</span>
        </div> -->

    <mat-stepper
      orientation="{{ mobileSummaryStepper ? 'vertical' : 'horizontal' }}"
      [linear]="true"
      #stepper
    >
      <!-- SHIPPING INFORMATION -->

      <mat-step>
        <ng-template matStepLabel>{{
          "titles.list.review_order" | translate
        }}</ng-template>

        <div class="purchase-summary-wrapper">
          <!-- PURCHASE SUMMARY TABLE  -->

          <mat-table
            *ngIf="selectedProducts.length > 0 && !mobileSummaryItems"
            [dataSource]="selectedProducts"
            class="mat-elevation-z8 checkout-table"
          >
            <!-- PRODUCT SUMMARY TITLE HEADER ROW/CELL -->
            <ng-container matColumnDef="tableTitle">
              <mat-header-cell *matHeaderCellDef class="checkout-table-title">
                <span> {{ "tables.purchase_reserve" | translate }} </span>
              </mat-header-cell>
            </ng-container>

            <!-- PRODUCT SUMMARY PHOTO COLUMN -->
            <ng-container matColumnDef="photo-summary">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell"
              >
              </mat-header-cell>
              <mat-cell *matCellDef="let product" class="checkout-table-cell">
                <div>
                  <div
                    mat-card-avatar
                    class="student-avatar"
                    style="background-image: url({{ students[product.type] }})"
                  ></div>
                </div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- PRODUCT SUMMARY PRODUCT COLUMN -->
            <ng-container matColumnDef="product">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell"
              >
                <span>{{ "titles.edit.product" | translate }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let product" class="checkout-table-cell">
                <div
                  style="display: flex; flex-direction: column; margin-top: 8px"
                >
                  <div>
                    <span style="display: {{ 'es' | translate }}">{{
                      product.name_es
                    }}</span>
                    <span style="display: {{ 'en' | translate }}">{{
                      product.name_en
                    }}</span>
                    <span style="display: {{ 'cat' | translate }}">{{
                      product.name_cat
                    }}</span>
                  </div>
                  <div class="product-description-description">
                    <div
                      *ngFor="
                        let description of productDescriptions[product.id]
                      "
                    >
                      <div>
                        <span
                          style="display: {{
                            'es' | translate
                          }}; font-size: 14px"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_es }}</span
                        >
                        <span
                          style="display: {{
                            'en' | translate
                          }}; font-size: 14px"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_en }}</span
                        >
                        <span
                          style="display: {{
                            'cat' | translate
                          }}; font-size: 14px"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_cat }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- PRODUCT SUMMARY GRADE COLUMN -->
            <ng-container matColumnDef="grade">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell"
              >
                <span>{{ "tables.grade" | translate }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let product" class="checkout-table-cell">
                <div>
                  {{ students["grade_name"] }}
                </div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- PRODUCT SUMMARY STUDENT COLUMN -->
            <ng-container matColumnDef="student">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell"
              >
                <span>{{ "tables.student_name" | translate }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let product" class="checkout-table-cell">
                <div>
                  {{ students["name"] }}
                </div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- PRODUCT SUMMARY UNIT PVP COLUMN -->
            <ng-container matColumnDef="unit_pvp">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell unit-header"
              >
                <span>{{ "tables.unit_pvp" | translate }} </span>
              </mat-header-cell>
              <mat-cell
                *matCellDef="let product"
                class="checkout-table-cell unit-cell"
              >
                <div>
                  {{ product.value }}€ <br />
                  {{ "tables.vat_included" | translate }}
                </div>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                <div>
                  <span class="total-checkout"
                    >Total: {{ totalValueAmount.amount }}€
                    <span style="font-size: 14px; color: black"
                      >*{{ "tables.vat_included" | translate }}</span
                    >
                  </span>
                </div>
              </mat-footer-cell>
            </ng-container>

            <!-- PRODUCT SUMMARY QUANTITY COLUMN -->
            <ng-container matColumnDef="quantity">
              <mat-header-cell
                *matHeaderCellDef
                class="checkout-table-header-cell quantity-header"
              >
                <span> {{ "tables.unit" | translate }}</span>
              </mat-header-cell>
              <mat-cell
                *matCellDef="let product"
                class="checkout-table-cell quantity-cell"
              >
                <!-- <div>
                                {{ product.unit }}
                            </div> -->

                <button mat-button [matMenuTriggerFor]="summaryMenu" [disabled]="all_products[product.id].is_gift">
                  <span>{{ product.unit }} &nbsp;</span>
                  <mat-icon> keyboard_arrow_down </mat-icon>
                </button>
                <mat-menu #summaryMenu="matMenu">
                  <div style="height: 200px; text-align: center">
                    <button
                      mat-menu-item
                      (click)="summaryProductQuantityHandler(0, product.id)"
                      style="text-align: center"
                    >
                      <span>
                        <mat-icon style="margin: 0">delete</mat-icon>
                      </span>
                    </button>
                    <mat-divider style="width: 100%"></mat-divider>
                    <div *ngFor="let number of numberList">
                      <button
                        mat-menu-item
                        (click)="
                          summaryProductQuantityHandler(number, product.id)
                        "
                        style="text-align: center"
                      >
                        <span>{{ number }}</span>
                      </button>
                    </div>
                  </div>
                </mat-menu>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                <div>
                  <button
                    mat-button
                    matStepperNext
                    style="background-color: #5fbeb5; color: white"
                  >
                    {{ "inputs.next" | translate }}
                  </button>
                </div>
              </mat-footer-cell>
            </ng-container>

            <!-- PRODUCT SUMMARY PVP COLUMN -->
            <!-- <ng-container matColumnDef="pvp">
                        <mat-header-cell *matHeaderCellDef class="checkout-table-header-cell pvp-header">
                            <span>P.V.P. <span class="vat-text">*{{'tables.vat_included' |
                                    translate}}</span></span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let product" class="checkout-table-cell pvp-cell">
                            <div>
                                {{ (product.value * product.unit).toFixed(2) }}€
                            </div>
                        </mat-cell>

                        <mat-footer-cell *matFooterCellDef>
                            <div>
                                <span class="total-checkout">Total: {{ totalValueAmount.amount }}€
                                    <span style="font-size: 14px;color: black;">*{{'tables.vat_included' |
                                        translate}}</span>
                                </span>
                            </div>
                        </mat-footer-cell>

                    </ng-container> -->

            <!-- PRODUCT SUMMARY DELETE COLUMN -->
            <!-- <ng-container matColumnDef="delete">
                        <mat-header-cell *matHeaderCellDef class="checkout-table-header-cell pvp-header">
                        </mat-header-cell>
                        <mat-cell *matCellDef="let product" class="checkout-table-cell pvp-cell"
                            style="padding: 0 32px 0 0;">
                            <button mat-flat-button (click)="removeProductFromCheckout(product.id)">
                                <span style="color: blue;">{{ 'buttons.delete' | translate }}</span>
                            </button>
                        </mat-cell>

                        <mat-footer-cell *matFooterCellDef>

                        </mat-footer-cell>

                    </ng-container> -->

            <mat-header-row *matHeaderRowDef="['tableTitle']"></mat-header-row>
            <mat-header-row
              *matHeaderRowDef="checkoutSummaryColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: checkoutSummaryColumns"
            ></mat-row>
            <mat-footer-row
              *matFooterRowDef="checkoutSummaryColumns"
            ></mat-footer-row>
          </mat-table>

          <div *ngIf="mobileSummaryItems" class="product-card-wrapper">
            <div *ngFor="let product of selectedProducts">
              <mat-divider
                style="border-top-color: gray; width: 100%"
              ></mat-divider>

              <div class="product-card">
                <div>
                  <div
                    class="student-avatar-small"
                    style="background-image: url({{
                      students['primary_photo']
                    }})"
                  ></div>
                  <span>{{ students["name"] }}</span>
                  <span>{{ students["grade_name"] }}</span>
                </div>

                <div>
                  <div class="product-name">
                    <span style="display: {{ 'es' | translate }}">{{
                      product.name_es
                    }}</span>
                    <span style="display: {{ 'en' | translate }}">{{
                      product.name_en
                    }}</span>
                    <span style="display: {{ 'cat' | translate }}">{{
                      product.name_cat
                    }}</span>
                  </div>

                  <div class="product-descriptions">
                    <div
                      *ngFor="
                        let description of productDescriptions[product.id]
                      "
                    >
                      <div>
                        <span style="display: {{ 'es' | translate }}"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_es }}</span
                        >
                        <span style="display: {{ 'en' | translate }}"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_en }}</span
                        >
                        <span style="display: {{ 'cat' | translate }}"
                          >{{
                            description.unit ? description.unit : "*"
                          }}
                          &nbsp; {{ description.description_cat }}</span
                        >
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="product-price">
                      <span>
                        <span style="color: gray"
                          >{{ "inputs.value" | translate }}:
                        </span>
                        {{ product["value"] }} €
                      </span>
                    </div>
                    <div class="product-quantity">
                      <span style="color: gray"
                        >{{ "buttons.quantity_short" | translate }}:</span
                      >
                      <button mat-button [matMenuTriggerFor]="summaryMenu" [disabled]="all_products[product.id].is_gift">
                        <span>{{ product.unit }} &nbsp;</span>
                        <mat-icon> keyboard_arrow_down </mat-icon>
                      </button>
                      <mat-menu #summaryMenu="matMenu">
                        <div style="height: 200px; text-align: center">
                          <button
                            mat-menu-item
                            (click)="
                              summaryProductQuantityHandler(0, product.id)
                            "
                            style="text-align: center"
                          >
                            <span>
                              <mat-icon style="margin: 0">delete</mat-icon>
                            </span>
                          </button>
                          <mat-divider style="width: 100%"></mat-divider>
                          <div *ngFor="let number of numberList">
                            <button
                              mat-menu-item
                              (click)="
                                summaryProductQuantityHandler(
                                  number,
                                  product.id
                                )
                              "
                              style="text-align: center"
                            >
                              <span>{{ number }}</span>
                            </button>
                          </div>
                        </div>
                      </mat-menu>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>{{
          "inputs.personal_data" | translate
        }}</ng-template>

        <div
          class="personal-information-form"
          [formGroup]="reservationDataForm"
        >
          <div class="personal-information-row">
            <span>{{ "inputs.complete_name" | translate }}:</span>
            <div>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  [formControlName]="'name'"
                  required
                />
                <mat-hint>{{ "inputs.name" | translate }}</mat-hint>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  [formControlName]="'surname'"
                  required
                />
                <mat-hint>{{ "inputs.surname" | translate }}</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="personal-information-row">
            <span>{{ "inputs.identifier" | translate }}:</span>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="text"
                [formControlName]="'id_num'"
                required
              />
              <mat-hint>{{ "inputs.identifier_type" | translate }}</mat-hint>
            </mat-form-field>
          </div>
          <div class="personal-information-row">
            <span>{{ "inputs.contact_phone" | translate }}:</span>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="tel"
                [formControlName]="'tel_num'"
                required
              />
              <mat-hint>{{ "inputs.phone" | translate }}</mat-hint>
            </mat-form-field>
          </div>

          <div class="personal-information-row">
            <span></span>
            <div style="flex-direction: row">
              <mat-checkbox
                [formControlName]="'accept_conditions'"
              ></mat-checkbox>
              &nbsp; &nbsp;
              <a
                href="https://www.makneticfoto.com/condiciones-venta/"
                target="_blank"
                style="color: black; font-size: 16px"
                >{{ "inputs.terms_accept_message" | translate }}</a
              >
            </div>
          </div>

          <p class="reservation-info">
            <span style="font-weight: 800">Nota informativa:</span> Al pulsar el
            botón Completar Reserva está comprando los productos elegidos, los
            cuales se cobrarán a través del recibo escolar. No será posible
            anular la compra fuera del periodo establecido para reservar. Una
            vez entregado el pedido en la escuela no se admitirán devoluciones,
            salvo en los casos indicados en las Condiciones de Venta.
          </p>

          <div class="personal-information-row">
            <span></span>
            <button
              mat-flat-button
              style="background-color: #5fbeb5"
              (click)="checkoutHandler(reservationDataForm)"
            >
              <span style="color: white">{{
                "buttons.order" | translate
              }}</span>
            </button>
          </div>
        </div>

        <div>
          <!-- <button mat-button matStepperPrevious>Back</button> -->
        </div>
      </mat-step>
    </mat-stepper>
  </div>
</div>
